<template>
  <div style="background: #eee;height: 100%;width:100%;display: flex;flex-direction: column;">
    <div class="top-nav">
      <span class="nav-title">设置签署位置</span>
      <div class="nav-opt">
        <Button class="opt-close" @click="closeSign">取消</Button>
        <Button type="primary" class="confirm" @click="commitSign">确认提交</Button>
      </div>
    </div>
    <div id="elesign" class="elesign">
      <Row style="width:100%">
        <Col :span="4" style="height: 100%;">
          <div class="left-title">签署印章</div>
          <draggable class="draggable" v-model="mainImagelist" :group="{ name: 'itext', pull: 'clone' }" :sort="false"
                     @end="end">
            <transition-group type="transition">
              <li v-for="item in mainImagelist" :key="item.id" class="item" style="text-align:center;">
                <div :class="item.type === 3 ? 'sign_item_per' : 'sign_item'">
                  <img :src="item.sealUrl" width="100%;" height="100%" class="imgstyle"/>
                  <span>{{ item.name }}</span>
                </div>
              </li>
            </transition-group>
          </draggable>
        </Col>
        <Col :span="20" class="pCenter" style="height: 100%;display: flex;flex-direction: column">
          <div class="page">
            <span style="position:absolute;left: 0;margin-left: 10px;">测试.pdf</span>
            <div class="shu"></div>
            <Page class="changePage" :current="pageNum" :total="numPages" :page-size="1" simple
                  @on-change="changePage"/>
            <div class="shu"></div>
            <el-button class="btn-outline-dark" @click="zoomIn">-</el-button>
            <p style="margin:0 10px">{{ (percentage * 100).toFixed(0) + '%' }}</p>
            <el-button class="btn-outline-dark" @click="zoomOut">+</el-button>
            <div class="shu"></div>
            <!--            <el-button class="btn-outline-dark" @click="prevPage">上一页</el-button>-->
            <!--            <el-button class="btn-outline-dark" @click="nextPage">下一页</el-button>-->
            <!--            <el-button class="btn-outline-dark">{{ pageNum }}/{{ numPages }}页</el-button>-->
            <!--          <el-input-number style="margin:0 5px;border-radius:5px;" class="btn-outline-dark" v-model="pageNum" :min="1"-->
            <!--                           :max="numPages" label="输入页码"></el-input-number>-->
            <!--          <el-button class="btn-outline-dark" @click="cutover">跳转</el-button>-->
          </div>
          <div style="position: relative;height: 763px;width: 100%;overflow: scroll;">
            <canvas id="the-canvas"/>
            <!-- 盖章部分 -->
            <canvas id="ele-canvas"></canvas>
          </div>
          <!--          <div class="ele-control" style="margin-bottom:2%;">-->
          <!--            <el-button class="btn-outline-dark" @click="removeSignature">删除签章</el-button>-->
          <!--            <el-button class="btn-outline-dark" @click="clearSignature">清除所有签章</el-button>-->
          <!--            <el-button class="btn-outline-dark" @click="submitSignature">提交所有签章信息</el-button>-->
          <!--          </div>-->
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import {fabric} from 'fabric';

let pdfjsLib = require("pdfjs-dist");
import workerSrc from "pdfjs-dist/build/pdf.worker.entry";

pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
import draggable from "vuedraggable";

export default {
  components: {draggable},
  data() {
    return {
      //pdf预览
      pdfUrl: '',
      pdfDoc: null,
      numPages: 1,
      pageNum: 1,
      scale: 1.04,
      pageRendering: false,
      pageNumPending: null,
      sealUrl: '',
      signUrl: '',
      canvas: null,
      ctx: null,
      canvasEle: null,
      whDatas: null,
      mainImagelist: [],
      taskInfo: {},
      percentage: 1.04,
      signPlaceData: null,
      signType: null
    }
  },
  watch: {
    whDatas: {
      handler() {
        // const loading = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // });
        if (this.whDatas) {
          console.log(this.whDatas)
          // loading.close();
          this.renderFabric();
          this.canvasEvents();
          let eleCanvas = document.querySelector("#ele-canvas");
          // eleCanvas.style = "border:1px solid #5ea6ef";
        }
      },
    },
    scale() {
      this.commonSign(this.pageNum);
    },
    pageNum() {
      this.commonSign(this.pageNum);
      this.queueRenderPage(this.pageNum);
    }
  },
  computed: {
    hasSigna() {
      return this.canvasEle && this.canvasEle.getObjects()[0] ? true : false;
    },
  },
  created() {
  },
  methods: {
    initSignData(signPlaceData, signData, signType) {
      this.signType = signType;
      this.signPlaceData = signPlaceData;
      signData.map((i, index) => {
        
        this.mainImagelist.push({
          id: index,
          sealUrl: i.partyType === 3 ? require('@/assets/images/common/qz-per.png') : require('@/assets/images/common/qz.png'),
          name: i.partyName,
          type: i.partyType
        });
      })
      this.commonSign(this.pageNum, true);
    },
    commitSign() {
      if (!this.signPlaceData) {
        this.$XModal.alert({
          message: '所有签约方至少有一处签署位置',
          status: "error",
        });
        return
      }
      if (this.signType !== 1) {
        this.mainImagelist.map(i => {
          i.count = 0;
          for (let key in this.signPlaceData) {
            for (let val in this.signPlaceData[key]) {
              if (this.signPlaceData[key][val].name === i.name && this.signPlaceData[key][val].type === i.type) {
                i.count += 1;
              }
            }
          }
        })
        let boolean = false;
        this.mainImagelist.map(i => {
          if (i.count < 1) {
            boolean = true;
          }
        })
        if (boolean) {
          this.$XModal.alert({
            message: '所有签约方至少有一处签署位置',
            status: "error",
          });
          return
        }
      }
      this.$emit('setSign', this.signPlaceData);
    },
    closeSign() {
      this.signPlaceData = {};
      this.$emit('close');
    },
    changePage(e) {
      this.pageNum = e;
    },
    //pdf预览
    zoomIn() {
      console.log("缩小");
      if (this.scale <= 0.5) {
        this.$message.error("已经显示最小比例")
      } else {
        this.scale -= 0.25;
        this.percentage -= 0.25;
        this.renderPage(this.pageNum).then(() => {
          this.changeFabric();
        });
        // this.renderFabric();

      }
    },
    zoomOut() {
      console.log("放大")
      if (this.scale >= 2.2) {
        this.$message.error('已经显示最大比例')
      } else {
        this.scale += 0.25;
        this.percentage += 0.25;
        this.renderPage(this.pageNum).then(() => {
          this.changeFabric();
        });
        // this.renderFabric();
      }
    },
    renderPage(num) {
      let _this = this;
      this.pageRendering = true;
      return this.pdfDoc.getPage(num).then((page) => {
        let viewport = page.getViewport(_this.scale);//设置视口大小
        _this.canvas.height = viewport.height;
        _this.canvas.width = viewport.width;

        // Render PDF page into canvas context
        let renderContext = {
          canvasContext: _this.ctx,
          viewport: viewport,
        };
        let renderTask = page.render(renderContext);
        // Wait for rendering to finish

        renderTask.promise.then(() => {
          _this.pageRendering = false;
          if (_this.pageNumPending !== null) {
            // New page rendering is pending
            this.renderPage(_this.pageNumPending);
            _this.pageNumPending = null;
          }
        });
      });
    },
    queueRenderPage(num) {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
    },
    prevPage() {
      this.confirmSignature();
      if (this.pageNum <= 1) {
        return;
      }
      this.pageNum--;
    },
    nextPage() {
      this.confirmSignature();
      if (this.pageNum >= this.numPages) {
        return;
      }
      this.pageNum++;
    },
    cutover() {
      this.confirmSignature();
    },
    //渲染pdf，到时还会盖章信息，在渲染时，同时显示出来，不应该在切换页码时才显示印章信息
    showpdf(pdfUrl) {
      let _this = this;

      // let caches = JSON.parse(localStorage.getItem('signs')); //获取缓存字符串后转换为对象
      // console.log(caches);
      // if (caches !== undefined && caches !== null) {
      //   let datas = caches[this.pageNum];
      //   if (datas !== null && datas !== undefined) {
      //     for (let index in datas) {
      //       this.addSeal(datas[index], datas[index].left, datas[index].top, datas[index].index);
      //     }
      //   }
      // }

      this.canvas = document.getElementById("the-canvas");
      this.ctx = this.canvas.getContext("2d");
      pdfjsLib.getDocument({url: pdfUrl, rangeChunkSize: 65536, disableAutoFetch: false}).promise.then((pdfDoc_) => {
        _this.pdfDoc = pdfDoc_;
        _this.numPages = _this.pdfDoc.numPages;
        this.renderPage(_this.pageNum).then(() => {
          this.renderPdf({
            width: _this.canvas.width,
            height: _this.canvas.height,
          });
        });
        this.commonSign(_this.pageNum, true);
      });
    },
    /**
     *  盖章部分开始
     */
    // 设置绘图区域宽高
    renderPdf(data) {
      this.whDatas = data;
      // document.querySelector("#elesign").style.width = data.width + "px";
    },
    // 生成绘图区域
    renderFabric() {
      let canvaEle = document.querySelector("#ele-canvas");
      // let canvas = document.querySelector("#the-canvas");
      canvaEle.width = this.whDatas.width;
      canvaEle.height = this.whDatas.height;

      this.canvasEle = new fabric.Canvas(canvaEle);
      let container = document.querySelector(".canvas-container");
      container.style.position = "absolute";
      container.style.top = "10px";
      container.style.left = "0px";
      container.style.right = "0px";
      container.style.margin = "0 auto";
      // container.style.left = "30%";
    },
    changeFabric() {
      let canvaEle = document.querySelector("#ele-canvas");
      canvaEle.width = this.canvas.width;
      canvaEle.height = this.canvas.height;
      this.canvasEle.setDimensions({
        width: this.canvas.width,
        height: this.canvas.height
      });
    },
    // 相关事件操作哟
    canvasEvents() {
      let _this = this;
      // 拖拽边界 不能将图片拖拽到绘图区域外
      this.canvasEle.on("object:moving", function (e) {
        let obj = e.target;
        // if object is too big ignore
        if (obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width) {
          return;
        }
        obj.setCoords();
        // top-left  corner
        if (obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0) {
          obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top);
          obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left);
        }
        // bot-right corner
        if (obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height || obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width) {
          obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top);
          obj.left = Math.min(obj.left, obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left);
        }
        _this.confirmSignature();
      });
    },
    //渲染图标
    renderIcon(image, initialAngle) {
      return function (ctx, left, top, styleOverride, fabricObject) {
        let size = this.cornerSize;
        ctx.save();
        ctx.translate(left, top);
        ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle + initialAngle));
        ctx.drawImage(image, -size / 2, -size / 2, size, size);
        ctx.restore();
      };
    },
    // 添加公章
    addSeal(item, left, top, index) {
      let _this = this;
      // 删除图标
      const deleteIconURL = require('@/assets/images/common/sign-close.png');
      //删除事件回调
      const deletecallback = (img, isError) => {
        if (!isError) {
          fabric.Object.prototype.controls.delete = new fabric.Control({
            // x和y设置该控制点和第二列中间的控制点重合
            x: 0.5,
            y: -0.5,
            // offsetX和offsetY设置该控制点在水平和竖直两个方向上
            // 偏移的距离（单位px）
            offsetX: 10,
            offsetY: 0,
            // 光标移动到该控制点时变为一个手的图标
            cursorStyle: 'pointer',
            // 自定义的值，可忽略
            actionName: "delete",
            // 设置当点击了该控制点，鼠标弹起是执行的动作处理方法
            mouseUpHandler: () => _this.deleteObject(),
            //渲染图标
            render: _this.renderIcon(img._element, 0),
            cornerSize: 15
          });
        }
      };
      fabric.Image.fromURL(deleteIconURL, deletecallback);
      fabric.Image.fromURL(
          item.sealUrl,
          (oImg) => {
            let text;
            if (item.type !== 3) {
              oImg.set({
                // left: left * this.scale,
                // top: top * this.scale,
                // angle: 10,
                originX: 'center',
                originY: 'center',
              });
              oImg.scaleToWidth(125 * this.scale);
              oImg.scaleToHeight(125 * this.scale);
              // oImg.scale(this.scale); //图片缩小一


              text = new fabric.Text(item.name, {
                // left: 10,
                top: oImg.height * this.scale / 2 - (35 * this.scale),
                width: oImg.width * this.scale,
                fontSize: 14,
                fill: 'white',
                originX: 'center',
                textBackgroundColor: '#706e6e',
              });
            } else {
              oImg.set({
                // left: left * this.scale,
                // top: top * this.scale,
                // angle: 10,
                // scaleX: 1,
                // scaleY: 1,
              });
              oImg.scaleToWidth(102 * this.scale);
              oImg.scaleToHeight(45 * this.scale);

              text = new fabric.Text(item.name, {
                left: 0,
                top: 0,
                fontSize: 14,
                fill: 'white',
                textBackgroundColor: '#706e6e',
              });
            }

            let group = new fabric.Group([oImg, text], {
              left: left * this.scale,
              top: top * this.scale,
              name: item.name,
              index: index,
              scaleX: this.scale,
              scaleY: this.scale,
            });

            group.setControlVisible('ml', false);//左
            group.setControlVisible('mb', false);//下
            group.setControlVisible('mr', false);//右
            group.setControlVisible('mt', false);//上
            group.setControlVisible('tl', false);//左上
            group.setControlVisible('bl', false);//左下
            group.setControlVisible('tr', false);//右上
            group.setControlVisible('br', false);//右下
            group.setControlVisible('mtr', false);//旋转

            this.canvasEle.add(group);
          }
      );
    },
    // 删除签章
    removeSignature() {
      this.canvasEle.remove(this.canvasEle.getActiveObject())
    },
    deleteObject() {
      // 获取画布当前选中的对象
      let activeObject = this.canvasEle.getActiveObject();
      if (activeObject) {
        this.canvasEle.remove(activeObject);
        this.canvasEle.renderAll();
      }
      this.submitSignature();
    },
    //翻页展示盖章信息
    commonSign(pageNum, isFirst = false) {
      if (isFirst == false) this.canvasEle.remove(this.canvasEle.clear()); //清空页面所有签章
      // let caches = JSON.parse(localStorage.getItem('signs')); //获取缓存字符串后转换为对象
      let caches = this.signPlaceData;
      console.log(caches);
      if (caches == null) return false;
      let datas = caches[this.pageNum];
      if (datas != null && datas != undefined) {
        for (let index in datas) {
          this.addSeal(datas[index], datas[index].left, datas[index].top, datas[index].index);
        }
      }
    },
    //确认签章位置并保存到缓存
    confirmSignature() {
      let data = this.canvasEle.getObjects(); //获取当前页面内的所有签章信息
      // let caches = JSON.parse(localStorage.getItem('signs')); //获取缓存字符串后转换为对象
      let caches = this.signPlaceData;

      let signDatas = {}; //存储当前页的所有签章信息
      let i = 0;
      // let sealUrl = '';
      for (let val of data) {
        signDatas[i] = {
          width: val.width,
          height: val.height,
          top: val.top / this.scale,
          left: val.left / this.scale,
          // angle: val.angle,
          // translateX: val.translateX,
          // translateY: val.translateY,
          // scaleX: val.scaleX,
          // scaleY: val.scaleY,
          pageNum: this.pageNum,
          sealUrl: this.mainImagelist[val.index].sealUrl,
          index: val.index,
          name: this.mainImagelist[val.index].name,
          type: this.mainImagelist[val.index].type,
        }
        i++;
      }
      if (caches == null) {
        caches = {};
        caches[this.pageNum] = signDatas;
      } else {
        caches[this.pageNum] = signDatas;
      }
      // localStorage.setItem('signs', JSON.stringify(caches)); //对象转字符串后存储到缓存
      this.signPlaceData = caches;
    },
    //提交数据
    submitSignature() {
      this.confirmSignature();
      let caches = localStorage.getItem('signs');
      console.log(JSON.parse(caches));
      return false
    },
    //清空数据
    clearSignature() {
      this.canvasEle.remove(this.canvasEle.clear()); //清空页面所有签章
      localStorage.removeItem('signs'); //清除缓存
    },
    end(e) {
      let that = this;
      this.addSeal(this.mainImagelist[e.newDraggableIndex], e.originalEvent.layerX, e.originalEvent.layerY, e.newDraggableIndex);
      setTimeout(() => {
        that.confirmSignature();
      }, 1000)
    },
    //设置PDF预览区域高度
    setPdfArea(pdf) {
      this.pdfUrl = pdf;
      this.$nextTick(() => {
        this.showpdf(this.pdfUrl);//接口返回的应该还有盖章信息，不只是pdf
      });
    },
  },
}
</script>
<style scoped>

/*pdf部分*/

.pCenter {
  overflow-x: hidden;
}

#the-canvas {
  position: absolute;
  top: 10px;
  left: 0px;
  right: 0px;
  margin: 0px auto;
}

html:fullscreen {
  background: white;
}

.elesign {
  display: flex;
  flex: 1;
  /*flex-direction: column;*/
  position: relative;
  /* padding-left: 180px; */
  margin: auto;
  /* width:600px; */
  height: 100%;
  width: 100%;
}

.page {
  height: 38px;
  background-color: #f7f8fa;
  border-bottom: 1px solid rgb(229, 230, 235);
  border-left: 1px solid rgb(229, 230, 235);
  display: flex;
  align-items: center;
  justify-content: center;
}

#ele-canvas {
  /* border: 1px solid #5ea6ef; */
  overflow: hidden;
}

.ele-control {
  text-align: center;
  margin-top: 3%;
}

#page-input {
  width: 7%;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* .loadingclass{
    position: absolute;
    top:30%;
    left:49%;
    z-index: 99;
} */
.left {
  position: absolute;
  top: 42px;
  left: -5px;
  padding: 5px 5px;
  /*border: 1px solid #eee;*/
  /*border-radius: 4px;*/
}

.left-title {
  display: flex;
  height: 38px;
  background: #f7f8fa;
  align-items: center;
  padding: 0 16px;
  position: relative;
  border-bottom: 1px solid rgb(229, 230, 235);
}

li {
  list-style-type: none;
  padding: 10px;
}

.imgstyle {
  vertical-align: middle;
  /*width: 130px;*/
  /*background-image: url("tuo.png");*/
  background-repeat: no-repeat;
}

.right {
  position: absolute;
  top: 7px;
  right: -177px;
  margin-top: 34px;
  padding-top: 10px;
  padding-bottom: 20px;
  width: 152px;
  /*border: 1px solid #eee;*/
  /*border-radius: 4px;*/
}

.right-item {
  margin-bottom: 15px;
  margin-left: 10px;
}

.right-item-title {
  color: #777;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  font-weight: 400;
  text-align: left !important;
}

.detail-item-desc {
  color: #333;
  line-height: 20px;
  width: 100%;
  font-size: 12px;
  display: inline-block;
  text-align: left;
}

.btn-outline-dark {
  height: 16px;
  width: 16px;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 14px;
  color: black;
}

.btn-outline-dark:hover {
  background-color: #e5e6eb;
  border-color: #e5e6eb;
  color: black;
}

.btn-outline-dark:active {
  color: black;
}

.sign_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: solid 1px #e8eef2;
}

.sign_item img {
  width: 125px;
  height: 125px;
}

.sign_item span {
  padding: 0 5px;
  font-size: 14px;
  margin-top: -15px;
  color: white;
  background: grey;
}

.sign_item_per {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: solid 1px #e8eef2;
}

.sign_item_per img {
  width: 102px;
  height: 45px;
}

.sign_item_per span {
  padding: 0 5px;
  position: absolute;
  top: 0;
  left: 55px;
  font-size: 14px;
  color: white;
  background: grey;
}

.top-nav {
  width: 100%;
  height: 56px;
  background: rgb(29, 33, 41);
  display: flex;
  align-items: center;
}

.nav-title {
  padding: 0 24px;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  line-height: 24px;
}

.nav-opt {
  margin-left: auto;
  padding: 0 24px;
}

.opt-close {
  border-radius: 2px;
  border: 1px solid #e5e6eb;
  background: transparent;
  color: #fff;
}

.confirm {
  margin-left: 10px;
  border-radius: 2px;
  background-color: #1063f1;
  border-color: #1063f1;
}

.draggable {
  height: calc(100% - 38px);
  background: #fff;
  box-shadow: 1px 0 0 0 rgb(0 0 0 / 5%);
}

.changePage {

}

.changePage >>> .ivu-page-prev, .ivu-page-next {
  background: transparent;
}

.shu {
  width: 1px;
  height: 20px;
  background: #e7e7e7;
  margin: 0 16px;
}
</style>